import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtHospitalitySection({}) {
  const isMobile = useMobile();
  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 750 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/5cd64388a91807a19b4e2d68fc626c8c2c027936.jpg")}
    >
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
        }}
      >
        {/* left side */}
        <View
          style={{
            flex: isMobile ? 1 : 2,
            paddingLeft: isMobile ? 4 : 15,
            paddingRight: isMobile ? 4 : 15,
          }}
        >
          <NtSectionTitle style={{ textAlign: "left", fontSize: 28 }}>
            INTEGRATED HOTEL & GUEST COMMUNICATION EXPERIENCE
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 10 }}>
            Our Integrated Hotel & Guest Communication Experience connects
            guests and staff through a unified platform for real-time messaging,
            service requests, and personalized updates, enhancing satisfaction
            and streamlining hotel operations.
          </NtSectionDescription>

          <View
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              padding: 20,
              borderRadius: 10,
              borderWidth: 1,
              borderColor: "rgba(255, 255, 255, 0.1)",
              marginTop: 30,
            }}
          >
            <NtSectionTitle style={{ textAlign: "left" }}>
              Explore Our Mobile app
            </NtSectionTitle>
            <NtSectionDescription style={{ marginTop: 10 }}>
              Stay connected with hotel staff, friends and family staying on the
              same property using the app's unlimited calls and messages for the
              entire stay.
            </NtSectionDescription>
          </View>
        </View>

        {/* right side */}
        {!isMobile && (
          <View style={{ flex: 1, alignItems: "center" }}>
            <Image
              style={[
                {
                  width: 150,
                  height: 300,
                  resizeMode: "contain",
                },
              ]}
              source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
            />
          </View>
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 650,
  },
});

export default NtHospitalitySection;
